export const adminRoles = {
  superAdmin: "super_admin",
  admin: "admin",
  navigator: "navigator"
}

export const MIN_PASSWORD_LENGTH = 6